/* eslint-disable */
// NEEDS ATTENTION
// NEEDS ATTENTION
// NEEDS ATTENTION
// NEEDS ATTENTION
// NEEDS ATTENTION
// NEEDS ATTENTION
// NEEDS ATTENTION
// NEEDS ATTENTION
// NEEDS ATTENTION
// NEEDS ATTENTION
// NEEDS ATTENTION
// NEEDS ATTENTION
// NEEDS ATTENTION
// NEEDS ATTENTION
/* eslint-disable */



import React from 'react';
import styled from 'styled-components';
import * as Router from 'next/router';
import updateLocalePlugin from 'dayjs/plugin/updateLocale';
import relativeTimePlugin from 'dayjs/plugin/relativeTime';
import dayjs from 'dayjs';

import * as gtag from '../utils/gtag';
import * as s from '../utils/stream';
import * as U from './Utils';
import * as T from './Typography';
import * as UserContext from './UserContext';
import Link from '../components/Link';
import ImageInitials from './ImageInitials';
import ActivityCommentTextArea from './ActivityCommentTextArea';
import { Button } from './Button';



dayjs.extend(updateLocalePlugin);
dayjs.extend(relativeTimePlugin);


/**
 *
 *
 *
 *  Resources:
 *  - https://day.js.org/docs/en/customization/relative-time
 */
const relativeTime = {
  past: '%s',
  s:    '%ds',
  m:    '%ds',
  mm:   '%dm',
  h:    '1h',
  hh:   '%dh',
  d:    '1d',
  dd:   '%dd',
  M:    '%dd',
  MM:   '%dm',
  y:    '%dy',
  yy:   '%dy',
};


/**
 *  Comments are always part of an activity.
 *  Sometimes the entire activity data is going
 *  to get passed down as props, other times
 *  only the activity id will be supplied and
 *  fetching will happen inside `useEffect`.
 *
 *
 *  Resources:
 *  - https://getstream.io/activity-feeds/docs/javascript/reactions_introduction
 *  - https://github.com/GetStream/stream-js/blob/master/src/reaction.ts
 */
export default function ActivityComment(props) {

  const userInfo = React.useContext(UserContext.Context);
  const router = Router.useRouter();
  const data = props;

  const [ currShow, setCurrShow ] = React.useState(2);
  const [ comments, setComments ] = React.useState(data.latest_reactions?.comm || []);

  const numComm = comments.length;
  const hasMore = numComm > currShow;

  return (
    <React.Fragment>
      {!!numComm && (
        <S.ContainerReverse>
          {comments.slice(0, currShow).map(getComment)}
          {hasMore && (
            <S.SubButton size='sml' colour='#f2e8e2' onClick={() => setCurrShow(currShow + 3)}>
              LOAD MORE COMMENTS ({numComm - currShow})
            </S.SubButton>
          )}
        </S.ContainerReverse>
      )}
      <ActivityCommentTextArea onPost={onComment} />
    </React.Fragment>
  );


  function getComment(elm) {

    const { name } = elm?.user?.data ?? {};
    const currId = elm?.user?.data?.id ?? elm?.user?.id;

    return (
      <S.CommentContainer key={elm.id}>
        <ImageInitials {...elm?.user?.data} size="sml"/>
        <S.InnerCommentContainer>
          <Link href={`/member/${currId}`}>
              <T.CM isHover opacity={1} weight={'bold'}>{name}</T.CM>
          </Link>
          <T.CM opacity={1}>{elm.data.text}</T.CM>
          <ActivitySubComment {...elm} />
        </S.InnerCommentContainer>
      </S.CommentContainer>
    );
  }


  async function onComment(text) {

    const isMyself = (data.actor.id === userInfo.id);
    const otps = {targetFeeds: isMyself ? [] : ['notification:' + data.actor.id]};
    const payload = {text: text};
    const client = await s.connect();
    const comment = await client?.reactions?.add('comm', props.id, payload, otps);


    gtag.event({
      name: gtag.GA_EVENT.MESSAGE_ENGAGEMENT,
      category: 'Messaging',
      label: 'Comment added',
      value: router.route,
    });

    setComments(prev => [comment].concat(prev));
  }
}


function ActivitySubComment(props) {

  dayjs.updateLocale('en', {relativeTime});
  const router = Router.useRouter();
  const [ isOpen, setIsOpen ] = React.useState(false);
  const [ isView, setIsView ] = React.useState(false);
  const [ replies, setReplies ] = React.useState(props.latest_children?.reply);
  const time = dayjs(props.data.time ?? props.created_at).fromNow(true);
  const numReplies = replies?.length;

  return (
    <React.Fragment>
      <SS.Container>
        <SS.HeaderContainer>
          <T.CS isHover={true} onClick={onReply}>Reply</T.CS>
          <S.Dot />
          <T.CS>{time}</T.CS>
        </SS.HeaderContainer>
        {isView ? (
          <S.ContainerReverse>
            {replies?.map(getComment)}
          </S.ContainerReverse>
        ) : numReplies && (
          <S.SubButton size='sml' colour='#f2e8e2' onClick={() => setIsView(true)}>
            VIEW REPLIES ({numReplies})
          </S.SubButton>
        )}
      </SS.Container>
      {isOpen && (
        <React.Fragment>
          <U.Space style={{height: 5}} />
          <ActivityCommentTextArea onPost={onComment} isSmall />
        </React.Fragment>
      )}
    </React.Fragment>
  );

  function onReply() {
    setIsOpen(true);
    setIsView(true);
  }

  function getComment(elm) {

    const { name } = elm.user.data;
    const currId = elm?.user?.data?.id ?? elm?.user?.id;
    const time = dayjs(elm.created_at).fromNow(true);

    return (
      <SS.ReplyContainer key={elm.id}>
        <ImageInitials {...elm.user.data} size={'sml'} />
        <SS.ReplyInnerContainer>
          <Link href={`/member/${currId}`}>
            <T.CM opacity={1} weight={'bold'}>{name}</T.CM>
          </Link>
          <T.CM opacity={1}>{elm.data.text}</T.CM>
          <T.CS>{time}</T.CS>
        </SS.ReplyInnerContainer>
      </SS.ReplyContainer>
    );
  }

  async function onComment(text) {

    const data = { text: text };
    const opts = { targetFeeds: ['notification:' + props.user.id] };
    const client = await s.connect();
    const reply = await client?.reactions?.addChild('reply', props.id, data, opts);
    setReplies(prev => [reply].concat(prev ?? []));


    gtag.event({
      name: gtag.GA_EVENT.MESSAGE_ENGAGEMENT,
      category: 'Messaging',
      label: 'Sub-comment',
      value: router.route,
    });

    setIsOpen(false);
  }
}


const S = {};

S.Container = styled.div`
  background: rgb(249, 244, 241);
  padding: 10px 20px;
`;

S.ContainerReverse = styled.div`
  background: rgb(249, 244, 241);
  display: flex;
  flex-direction: column-reverse;
  padding: 10px 20px;
`;

S.CommentContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: 10px;
  :last-child { margin-bottom: 0; }
`;

S.InnerCommentContainer = styled.div`
  flex: 1;
  margin-left: 10px;
`;

S.SubButton = styled(Button)`
  margin-bottom: 10px;
`;

S.Dot = styled.span`
  width: 15px;
  display: flex;
  justify-content: center;
  &::before { content: "·"; }
`;


const SS = {};

SS.Container = styled.div`
  width: 100%;
`;

SS.HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 4px 0;
`;

SS.ReplyContainer = styled.div`
  display: flex;
  align-items: flex-start;
  margin-top: 10px;
`;

SS.ReplyInnerContainer = styled.div`
  margin-left: 10px;
`;
